export enum CustomerCompensationPercentageOf {
    TOTAL_LOAN_AMOUNT = 'TOTAL_LOAN_AMOUNT',
    BASE_LOAN_AMOUNT = 'BASE_LOAN_AMOUNT'
}

export const customerCompensationPercentageOfDisplay = {
    [CustomerCompensationPercentageOf.TOTAL_LOAN_AMOUNT]: 'Total loan amount',
    [CustomerCompensationPercentageOf.BASE_LOAN_AMOUNT]: 'Base loan amount'
};
